import { createSelector } from 'reselect';
import { KEY, DecodedJWT } from './types';
import { GlobalState } from 'store/types';

const getAuthState = (state: GlobalState) => state[KEY];

const selectLoading = createSelector(getAuthState, (auth) => auth.loading);

const selectAdminError = createSelector(getAuthState, (auth) => auth.adminError);

const selectAdminPinError = createSelector(getAuthState, (auth) => auth.adminPinError);

const selectMaintenanceError = createSelector(getAuthState, (state) => state.maintenanceError);

const selectAdminId = createSelector(getAuthState, (auth) => (auth.admin as DecodedJWT).adminId);

const selectMaintenanceId = createSelector(getAuthState, (auth) => (auth.maintenance as DecodedJWT).adminId);

const selectAdminPinAuthorized = createSelector(getAuthState, (auth) => auth.adminPinAuthorized);

export const selectors = {
  selectLoading,
  selectAdminError,
  selectAdminPinError,
  selectMaintenanceError,
  selectAdminId,
  selectMaintenanceId,
  selectAdminPinAuthorized
};
